import { render } from "./IndicatorCard.vue?vue&type=template&id=4d0e3da0&scoped=true"
import script from "./IndicatorCard.vue?vue&type=script&lang=js"
export * from "./IndicatorCard.vue?vue&type=script&lang=js"

import "./IndicatorCard.vue?vue&type=style&index=0&id=4d0e3da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0e3da0"]])

export default __exports__